import { render, staticRenderFns } from "./publish-task.vue?vue&type=template&id=321d034d&scoped=true"
import script from "./publish-task.vue?vue&type=script&lang=js"
export * from "./publish-task.vue?vue&type=script&lang=js"
import style0 from "./publish-task.vue?vue&type=style&index=0&id=321d034d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d034d",
  null
  
)

export default component.exports